import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './style.css'
import { watchUpdates } from './update'

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- the linter cannot read .vue types; vue-tsc checks this
const app = createApp(App)
app.use(createPinia())
app.mount('#app')
watchUpdates()
